<div
  class="d-print-none menu-bar header-sm-height"
  #menuWrapper
  [class.open]="_horizontalMobileMenu"
>
  <a
    href="javascript:void(0)"
    (click)="toggleHorizontalMenu()"
    class="btn-link toggle-sidebar d-lg-none pg pg-close"
  >
  </a>
  <ul (cdkObserveContent)="_onContentChanges()">
    <li
      *ngFor="let item of _renduerMenuItems"
      [class.open]="item.open || item.mToggle === 'open'"
      [class.opening]="item.opening"
      [class.more]="item.type"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a
        href="javascript:void(0);"
        *ngIf="item.submenu; else singleLink"
        (click)="toggleLink($event, item)"
      >
        <span class="title">
          <ng-template [ngIf]="item.type != 'more'">{{
            item.label | translate
          }}</ng-template>
          <i *ngIf="item.type" class="pg pg-more"></i>
        </span>
        <span
          *ngIf="item.submenu && !item.type"
          class=" arrow"
          [class.open]="item.mToggle === 'open'"
        ></span>
      </a>
      <ng-template #singleLink>
        <!--<a *ngIf="item.routerLink && verAdminAccess(item.adminU)" [routerLink]="[item.routerLink]"><span class="title">{{ item.label | translate }}</span>-->
        <a
          *ngIf="item.routerLink"
          [routerLink]="[item.routerLink]"
          routerLinkActive="menuSelected"
          ><span class="title">{{ item.label | translate }}</span>
        </a>
        <a
          *ngIf="item.externalLink"
          href="{{ item.externalLink }}"
          [attr.target]="item.target"
          ><span class="title">{{ item.label | translate }}</span>
        </a>
      </ng-template>
      <ul *ngIf="item.submenu">
        <li *ngFor="let child of item.submenu">
          <a
            href="javascript:void(0);"
            *ngIf="child.submenu; else singleLinkChild"
            ><span class="title">{{ child.label }}</span>
            <span
              *ngIf="item.submenu"
              class=" arrow"
              [class.open]="item.mToggle === 'open'"
            ></span>
          </a>
          <ng-template #singleLinkChild>
            <a *ngIf="child.routerLink" [routerLink]="[child.routerLink]"
              ><span class="title">{{ child.label }}</span>
            </a>
            <a
              *ngIf="child.externalLink"
              href="{{ child.externalLink }}"
              [attr.target]="child.target"
              ><span class="title">{{ child.label }}</span>
            </a>
          </ng-template>
          <ul *ngIf="child.submenu" class="sub-menu">
            <li *ngFor="let lvl2 of child.submenu">
              <a *ngIf="lvl2.routerLink" [routerLink]="[lvl2.routerLink]"
                ><span class="title">{{ lvl2.label }}</span>
              </a>
              <a
                *ngIf="lvl2.externalLink"
                [routerLink]="[lvl2.externalLink]"
                [attr.target]="lvl2.target"
                ><span class="title">{{ item.label }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="ghost-nav-dropdown" [ngStyle]="item.ghost"></div>
    </li>
    <li *ngIf="_horizontalMobileMenu">
      <a href="javascript:void(0)" (click)="authSrv.logout()"
        ><span class="title text-success "
          ><b>{{ "15" | translate }}</b
          ><br />{{ authSrv.getUserEmail() }}</span
        ></a
      >
      <a
        *ngIf="_horizontalMobileMenu && authSrv.isUserDataAs()"
        href="javascript:void(0)"
        (click)="authSrv.logoutAs()"
        ><span class="title text-warning "
          ><b>{{ "15" | translate }}</b> {{ authSrv.userDataAs.client }}</span
        ></a
      >
      <!--<div style="width:40px; margin-top:50px">-->
      <!--<app-site-lang [siteMenu]=true></app-site-lang>-->
      <!--</div>-->
    </li>
  </ul>
</div>
